module.exports = __webpack_public_path__ + "static/img/pic_img_1.b4b8e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_img_1.png
// module id = WLxC
// module chunks = 0